var _rect, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgExclamationIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#F31F43"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.406 9C7.31267 9 7.22867 8.96733 7.154 8.902C7.08867 8.82733 7.056 8.74333 7.056 8.65V3.35C7.056 3.24733 7.08867 3.16333 7.154 3.098C7.22867 3.03267 7.31267 3 7.406 3H9.016C9.11867 3 9.20267 3.03267 9.268 3.098C9.33333 3.16333 9.366 3.24733 9.366 3.35V8.65C9.366 8.74333 9.33333 8.82733 9.268 8.902C9.20267 8.96733 9.11867 9 9.016 9H7.406ZM7.35 12.8C7.24733 12.8 7.16333 12.7673 7.098 12.702C7.03267 12.6367 7 12.5527 7 12.45V10.728C7 10.6253 7.03267 10.5413 7.098 10.476C7.16333 10.4013 7.24733 10.364 7.35 10.364H9.072C9.16533 10.364 9.24467 10.4013 9.31 10.476C9.38467 10.5413 9.422 10.6253 9.422 10.728V12.45C9.422 12.5433 9.38933 12.6273 9.324 12.702C9.25867 12.7673 9.17467 12.8 9.072 12.8H7.35Z",
    fill: "#FEFEFE"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExclamationIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/exclamation-icon.0c84f21d.svg";
export { ForwardRef as ReactComponent };